(() => {
  const base = document.currentScript?.src || '';
  const load = name => new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = new URL(name, base).href;
    script.defer = true;
    script.addEventListener('load', resolve, { once: true });
    script.addEventListener('error', reject, { once: true });
    document.head.appendChild(script);
  });

  load('kruzer-th3900-cro-core.js')
    .then(() => load('kruzer-th3900-runtime-fix.js'))
    .catch(() => {});
})();
